import orderConfirmationStyles from './order-confirmation';
document.addEventListener('DOMContentLoaded', function () {
  var callMeButton = document.getElementById('btnAddSrvBellhop');

  if(callMeButton){
    callMeButton.addEventListener('click', (e) => {
      BellhopPrepopulateLabor();
    });
  };

  function BellhopPrepopulateLabor() {
    var orderId = document.getElementById('hdnOrderNumber').value;
    window.open($('#hdnBellhopLink').val()+"?orderId="+orderId);
    return false;
  }
}, false);
